var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.663 2.918a1 1 0 0 1 .085 1.412l-7.68 8.666a1 1 0 0 1-1.418.08l-4.32-3.9A1 1 0 0 1 2.67 7.69l3.571 3.224 7.01-7.912a1 1 0 0 1 1.412-.085",
  clipRule: "evenodd"
})));
export { SvgCheckbox as ReactComponent };